import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, } from 'react';
import { RadioGroupContext, useRadioGroupContext } from './context.js';
import { Radio as BaseRadio } from './Radio.js';
/**
 * RadioGroup is component that should be used as wrapper for multiple Radios because it passes down to RadioGroup.Radio
 * components any props set on this component, for example "name"/"onChange" is shared through all of its Radio children
 * There is GroupLayout component in @cld/form to position vertically Group of radios
 */
export const RadioGroupCompoundParent = ({ children, ...restProps }) => {
    const contextValue = useMemo(() => ({ ...restProps }), [restProps]);
    return (_jsx(RadioGroupContext.Provider, { value: contextValue, children: children }));
};
const Radio = ({ id, value, isDisabled, inputProps, onChange, onFocus, onBlur, ...rest }) => {
    const radioGroupContextValue = useRadioGroupContext();
    const handleChange = useCallback((e) => {
        onChange?.(e.target.value, e);
        radioGroupContextValue.onChange?.(e.target.value, e);
    }, [radioGroupContextValue.onChange, onChange]);
    const handleFocus = useCallback((e) => {
        onFocus?.(e);
        radioGroupContextValue.onFocus?.(e);
    }, [radioGroupContextValue.onFocus, onFocus]);
    const handleBlur = useCallback((e) => {
        onBlur?.(e);
        radioGroupContextValue.onBlur?.(e);
    }, [radioGroupContextValue.onBlur, onBlur]);
    const isChecked = radioGroupContextValue.value === value;
    return (_jsx(BaseRadio, { ...rest, ...radioGroupContextValue, ...inputProps, id: id, value: value, checked: isChecked, "aria-checked": isChecked, disabled: isDisabled, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur }));
};
export const RadioGroup = Object.assign(RadioGroupCompoundParent, { Radio });
